var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Axios from "axios";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import uuid from "uuid";
import { Select } from "@material-ui/core";
import { maybe } from "tsmonads";
import serverUri from "../../config";
import { WebSocketMessage } from "../../serverConnection";
import AreaSelect from "../common/AreaSelect";
import EnterpriseSelect from "../common/EnterpriseSelect";
import InputField from "../common/InputField";
import Spinner from "../common/Spinner";
import DropzoneInput from "./DropzoneInput";
var uploadAgentVideo = function (data, history, token) {
    Axios.defaults.headers.common.Authorization = token;
    Axios.post(serverUri + "/api/videos/upload", data);
    history.push("/videos");
};
var VideoUpload = /** @class */ (function (_super) {
    __extends(VideoUpload, _super);
    function VideoUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.locationChanged = function (index, id) {
            var devices = _this.state.video.devices;
            if (id === "none" && index < devices.length - 1) {
                devices.splice(index, 1);
            }
            else if (index < devices.length) {
                devices[index] = id;
            }
            else if (id !== "none") {
                devices.push(id);
            }
            devices = devices.filter(function (d) { return d !== "none"; });
            _this.setState({ video: __assign(__assign({}, _this.state.video), { devices: devices }), changed: !_this.state.changed });
        };
        _this.storePreview = function () {
            var files = __spreadArrays(_this.state.files);
            files[0].preview = URL.createObjectURL(files[0]);
            _this.setState({ files: files });
        };
        var oldVideo = maybe(props.match.params.id).flatMap(function (id) { return maybe(props.videos.get(id)); });
        var devices = oldVideo
            .map(function (o) { return o.id; })
            .map(function (id) { return props.devices.filter(function (d) { return d.videos && d.videos.includes(id); }); })
            .map(function (devs) { return devs.map(function (d) { return d.id; }); });
        var onHost = oldVideo
            .map(function (o) { return o.id; })
            .map(function (id) { return props.devices.filter(function (d) { return d.hostVideos && d.hostVideos.includes(id); }); })
            .is(function (d) { return d.length > 0; });
        _this.state = {
            changed: false,
            errors: {},
            uploading: false,
            enterprise: oldVideo
                .map(function (v) { return v.enterprise; })
                .map(function (e) { return _this.props.enterprises.get(e); })
                .orUndefined(),
            video: oldVideo
                .map(function (o) { return (__assign(__assign({}, o), { onHost: onHost, devices: devices.orElse([]) })); })
                .orElse({
                deactivated: false,
                devices: devices.orElse([]),
                created: new Date(),
                updated: new Date(),
                duration: 30,
                id: uuid.v1(),
                onHost: false,
                enterprise: props.currentUser.enterprises[0],
                user: props.currentUser.role === "customer"
                    ? props.currentUser.id
                    : props.customers.valueSeq().toArray()[0].id,
            }),
            files: oldVideo.map(function (o) { return [{ preview: o.url }]; }).orElse([]),
        };
        return _this;
    }
    VideoUpload.prototype.render = function () {
        var _this = this;
        var customers = this.props.customers;
        var customerEnterprises = maybe(customers.get(this.state.video.user))
            .map(function (c) { return c.enterprises; })
            .orElse([]);
        var uploading = this.state.uploading;
        var maxLocations = maybe(this.state.video.user)
            .flatMap(function (id) { return maybe(_this.props.orders.find(function (o) { return o.user === id; })); })
            .map(function (o) { return o.locations; })
            .orElse(0);
        var locations = [];
        this.state.video.devices.forEach(function (device, i) {
            return locations.push(React.createElement(Select, { key: i + device, className: "select", placeholder: "Location", name: "location", onChange: function (e) { return _this.locationChanged(i, e.target.value); }, value: device },
                React.createElement("option", { key: 0, value: "none", selected: true }, "---"),
                _this.props.devices
                    .filter(function (d) { return d.validated; })
                    .map(function (d) { return (React.createElement("option", { key: d.id, value: d.id }, d.host + ", " + d.address + ", " + d.location)); })));
        });
        if (locations.length < maxLocations && this.state.video.devices[locations.length - 1] !== "none") {
            locations.push(React.createElement(Select, { key: this.state.video.devices.length, className: "select", placeholder: "Location", name: "location", onChange: function (e) { return _this.locationChanged(_this.state.video.devices.length, e.target.value); }, value: "none" },
                React.createElement("option", { key: 0, value: "none" }, "---"),
                this.props.devices
                    .filter(function (d) { return d.validated; })
                    .map(function (device) { return (React.createElement("option", { key: device.id, value: device.id }, device.host + ", " + device.address + ", " + device.location)); })));
        }
        var customerList = customers
            .valueSeq()
            .toArray()
            .filter(function (customer) {
            return maybe(_this.props.orders.find(function (o) { return o.user === customer.id; }))
                .map(function (o) { return o.status !== "inactive"; })
                .orElse(false);
        })
            .map(function (customer) { return (React.createElement("option", { key: customer.id, value: customer.id }, customer.company)); });
        var content = function () {
            var _a, _b;
            switch (true) {
                case uploading:
                    return React.createElement(Spinner, null);
                default:
                    return (React.createElement("div", { className: "content container" },
                        React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                            _this.props.match.params.id ? (React.createElement("h5", null, "Edit video meta-data")) : (React.createElement("h5", null,
                                "Upload a video",
                                _this.props.currentUser.role !== "customer" ? " for your customer" : "")),
                            React.createElement("br", null),
                            !_this.props.match.params.id && (React.createElement(DropzoneInput, { name: "video", files: _this.state.files, reset: function () {
                                    URL.revokeObjectURL(_this.state.files[0].preview);
                                    _this.setState({ files: [] });
                                }, onChange: function (files) {
                                    _this.setState({ files: files }, _this.storePreview);
                                } })),
                            (!_this.props.match.params.id || _this.state.video.user) && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "card-panel" },
                                    _this.props.currentUser.role !== "customer" && (React.createElement(React.Fragment, null,
                                        React.createElement("div", { className: "col s12 m6" },
                                            React.createElement("label", null, "Customer"),
                                            React.createElement(Select, { className: "select", placeholder: "Customer", name: "customer", onChange: function (e) {
                                                    return _this.setState({
                                                        video: __assign(__assign({}, _this.state.video), { user: e.target.value }),
                                                    });
                                                }, value: _this.state.video.user }, customerList)),
                                        React.createElement("br", null))),
                                    React.createElement(InputField, { value: _this.state.video.onHost, placeholder: "Host-only?", onChange: function (onHost) {
                                            _this.setState({
                                                video: __assign(__assign({}, _this.state.video), { onHost: !_this.state.video.onHost }),
                                            });
                                        }, type: "checkbox", label: "Also upload on host device?" })),
                                React.createElement("div", { className: "card-panel" },
                                    React.createElement("div", null,
                                        "Locations (",
                                        _this.state.video.devices.filter(function (d) { return d !== "none"; }).length,
                                        "/",
                                        maxLocations,
                                        ")"),
                                    React.createElement("br", null),
                                    locations))),
                            _this.state.video.user && customerEnterprises.length > 0 && (React.createElement(EnterpriseSelect, { notEmpty: true, value: (_a = _this.state.video.enterprise) !== null && _a !== void 0 ? _a : "none", enterprises: _this.props.enterprises
                                    .valueSeq()
                                    .filter(function (e) { return customerEnterprises.includes(e.id); })
                                    .toArray(), setEnterprise: function (id) {
                                    return _this.setState(__assign(__assign({}, _this.state), { enterprise: _this.props.enterprises.get(id) }));
                                } })),
                            _this.props.match.params.id && !_this.state.video.user && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "card-panel" },
                                    React.createElement(EnterpriseSelect, { notEmpty: true, value: (_b = _this.state.video.enterprise) !== null && _b !== void 0 ? _b : "none", enterprises: _this.props.enterprises.valueSeq().toArray(), setEnterprise: function (id) {
                                            return _this.setState(__assign(__assign({}, _this.state), { enterprise: _this.props.enterprises.get(id) }));
                                        } }),
                                    React.createElement(AreaSelect, { enterprise: _this.state.enterprise, value: _this.state.video.area, onChange: function (area) {
                                            return _this.setState({ video: __assign(__assign({}, _this.state.video), { area: area }) });
                                        } })))),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("button", { type: "submit", className: "right teal btn-flat white-text", onClick: function () { return _this.onSubmit(); } }, "Upload"),
                            React.createElement(Link, { to: "/videos", className: "red btn-flat left white-text" }, "Cancel"),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("br", null))));
            }
        };
        return React.createElement("div", null, content());
    };
    VideoUpload.prototype.onSubmit = function () {
        var _this = this;
        var formData = new FormData();
        formData.append("name", this.state.files[0].name);
        formData.append("video", this.state.files[0]);
        formData.append("id", this.state.video.id);
        formData.append("enterprise", this.state.video.enterprise);
        this.setState({ uploading: true }, function () {
            var video = __assign({}, _this.state.video);
            _this.props.send(WebSocketMessage("videos", "update", video));
            if (!_this.props.match.params.id) {
                uploadAgentVideo(formData, _this.props.history, _this.props.token);
            }
            else {
                _this.props.history.push("/videos");
            }
        });
    };
    return VideoUpload;
}(Component));
export default withRouter(VideoUpload);



//////////////////
// WEBPACK FOOTER
// ./src/components/videos/VideoUpload.tsx
// module id = 1271
// module chunks = 0